import { useEffect, useState, createContext, useContext, useMemo } from "react"
import io from "socket.io-client"
import { socketUrl } from "../utils/variables"

const SocketContext = createContext()

export function SocketProvider(props) {
  const [socket, setSocket] = useState(null)
  const [notificacion, setNotificacion] = useState(null)

  useEffect(() => {
    const socketInstance = io(socketUrl)

    setSocket(socketInstance)
    console.log("🔌 Conectado al socket:", socketInstance.id)

    // **Escuchar notificaciones del servidor**
    // CAMBIADO DE "serverMessage" A "notificacion"
    socketInstance.on("notificacion", (data) => {
      console.log("📩 Notificación recibida:", data)
      setNotificacion(data)
    })

    return () => {
      socketInstance.disconnect()
    }
  }, [])

  const memData = useMemo(
    () => ({ socket, notificacion }),
    [socket, notificacion]
  )

  return <SocketContext.Provider value={memData} {...props} />
}

export function useSocket() {
  const context = useContext(SocketContext)
  if (!context) {
    throw new Error("Error: SocketContext no está definido.")
  }
  return context
}
